export const defaultAppFilterValue = 'AllApps';



// WEBPACK FOOTER //
// ./src/constants/customer.constants.ts